module.exports = __webpack_public_path__ + "img/logs.f5c1e944.svg";